import { ResourcesConfig } from 'aws-amplify';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const commonOauthLocal = {
  redirectSignIn: ['http://localhost:4200/login'],
  redirectSignOut: ['http://localhost:4200/login'],
};

const commonOauthDev = {
  redirectSignIn: ['https://app.dev.navigate.ets-compass-nonprod.c.ets.org/login'],
  redirectSignOut: ['https://app.dev.navigate.ets-compass-nonprod.c.ets.org/login'],
};

const commonOauthTest = {
  redirectSignIn: ['https://app.test.ets-compass-nonprod.c.ets.org/login'],
  redirectSignOut: ['https://app.test.ets-compass-nonprod.c.ets.org/login'],
};

const commonOauthProd = {
  redirectSignIn: ['https://compass.futurenav.ets.org/login'],
  redirectSignOut: ['https://compass.futurenav.ets.org/login'],
};

interface AmplifyEnvironmentConfig {
  dev: ResourcesConfig;
  test: ResourcesConfig;
  prod: ResourcesConfig;
  [key: string]: ResourcesConfig;
}

const amplifyConfig: AmplifyEnvironmentConfig = {
  dev: {
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_vaIuvrgd0',
        userPoolClientId: '39sj8uip54l75agn7j5iji5518',
        identityPoolId: 'us-east-1:8bf8c48c-2593-4a0b-93b5-7f4c36dfc26b',
        loginWith: {
          oauth: {
            domain: 'skillchassis-dev-1.auth.us-east-1.amazoncognito.com',
            scopes: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile', 'phone'],
            responseType: 'code',
            ...(isLocalhost ? commonOauthLocal : commonOauthDev),
          },
        },
      },
    },
  },
  test: {
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_sv1Pth8L7',
        userPoolClientId: '55f2qgei4l778i39mt5qbhkcn1', 
        identityPoolId: 'us-east-1:374b2a93-1eac-472e-abaf-73ad04dbaaeb',
        loginWith: {
          oauth: {
            domain: 'skillschassis-test.auth.us-east-1.amazoncognito.com',
            scopes: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile', 'phone'],
            responseType: 'code',
            ...(isLocalhost ? commonOauthLocal : commonOauthTest),
          },
        },
      },
    },
  },
  prod: {
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_xnmqxM0HX',
        userPoolClientId: 'e4875p3pdbsbcsqcms6vdbiha',
        identityPoolId: 'us-east-1:feffa93a-f00b-44c8-acef-afc7b766168c',
        loginWith: {
          oauth: {
            domain: 'skillschassis-prod.auth.us-east-1.amazoncognito.com',
            scopes: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile', 'phone'],
            responseType: 'code',
            ...(isLocalhost ? commonOauthLocal : commonOauthProd),
          },
        },
      },
    },
  },
};

export function getAmplifyConfig(env: string = 'dev'): ResourcesConfig {
  return amplifyConfig[env] || amplifyConfig.dev;
}
